import { type CartControllerAddResponse } from '@redteclab/api/clients/bully'

import { cartIntermediateAccessorGetIsDataSuccessfullyAddedToCart } from '../model/cartIntermediateMutationResponseDataAccessor'

export const updateIsDataSuccessfullyAddedToCartFromResponse = (
  response: CartControllerAddResponse[] | CartControllerAddResponse | null,
  setIsDataSuccessfullyAddedToCart: (value: boolean) => void,
): void => {
  setIsDataSuccessfullyAddedToCart(
    cartIntermediateAccessorGetIsDataSuccessfullyAddedToCart(response),
  )
}
